import apiClient from './apiClient';

/**
 * Mirror of MAIE.Backend ai-capabilities.types. The backend serves the
 * merged map at /me/ai-capabilities; keep these unions in sync.
 */
export type AiUnavailableReason =
  | 'ok'
  | 'disabled'
  | 'quota_exceeded'
  | 'unavailable'
  | 'role_forbidden'
  /** This member sits on a records-only seat: full clinical privileges, no AI. */
  | 'no_ai_seat';

export interface AiFeatureStatus {
  available: boolean;
  reason: AiUnavailableReason;
}

export type AiFeatureKey =
  | 'scribe'
  | 'assistant'
  | 'ocr'
  | 'ocr_rx'
  | 'ocr_lab'
  | 'ocr_imaging'
  | 'ocr_attachments'
  | 'ocr_inbox'
  | 'ocr_record'
  | 'schedule_generator'
  /** Speaker enrolment — only the self-hosted speech service produces one. */
  | 'voiceprints';

export interface AiCapabilities {
  stack: { stt: boolean; llm: boolean; ocr: boolean };
  features: Record<AiFeatureKey, AiFeatureStatus>;
}

interface Envelope<T> {
  success?: boolean;
  data?: T;
}

const unwrap = <T>(payload: Envelope<T> | T): T => {
  if (payload && typeof payload === 'object' && 'data' in (payload as object)) {
    return (payload as Envelope<T>).data as T;
  }
  return payload as T;
};

export const aiCapabilitiesApi = {
  getMine: async (): Promise<AiCapabilities> => {
    const { data } = await apiClient.get('/me/ai-capabilities');
    return unwrap(data);
  },
};
